import React from 'react';
import IconButton from '@mui/material/IconButton';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
export const CreateButton: React.FC = () => {
    const auth = useAuth();
    return (
        <Link
            to={`/create/channel/${
                auth.user?.profile.sub ?? ''
            }/videos/upload`}
            style={{ color: 'white' }}
        >
            <IconButton
                data-cy="nav-bar-create-button"
                size="large"
                aria-label="create video"
                color="inherit"
                style={{ paddingTop: '0px', paddingBottom: '0px' }}
            >
                <VideoCallIcon />
            </IconButton>
        </Link>
    );
};
